import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import MyStreamWaveMyVoteVotes from "./MyStreamWaveMyVoteVotes";
import MyStreamWaveMyVoteInput from "./MyStreamWaveMyVoteInput";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { SingleWaveDropPosition } from "@/components/waves/drop/SingleWaveDropPosition";
import { cicToType, formatNumberWithCommas } from "@/helpers/Helpers";
import Link from "next/link";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ImageScale } from "@/helpers/image.helpers";
import { Tooltip } from "react-tooltip";
interface MyStreamWaveMyVoteProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly isChecked?: boolean;
  readonly onToggleCheck?: (dropId: string) => void;
  readonly isResetting?: boolean;
}
const MyStreamWaveMyVote: React.FC<MyStreamWaveMyVoteProps> = t0 => {
  const $ = _c(86);
  const {
    drop,
    onDropClick,
    isChecked: t1,
    onToggleCheck,
    isResetting: t2
  } = t0;
  const isChecked = t1 === undefined ? false : t1;
  const isResetting = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== drop.parts) {
    t3 = drop.parts.at(0)?.media.at(0);
    $[0] = drop.parts;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const artWork = t3;
  const t4 = drop.author.cic || 0;
  let t5;
  if ($[2] !== t4) {
    t5 = cicToType(t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const cicType = t5;
  let t6;
  if ($[4] !== drop || $[5] !== onDropClick) {
    t6 = () => {
      if (window.getSelection()?.toString()) {
        return;
      }
      onDropClick(drop);
    };
    $[4] = drop;
    $[5] = onDropClick;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const handleClick = t6;
  let t7;
  if ($[7] !== drop.id || $[8] !== onToggleCheck) {
    t7 = e => {
      e.stopPropagation();
      if (onToggleCheck) {
        onToggleCheck(drop.id);
      }
    };
    $[7] = drop.id;
    $[8] = onToggleCheck;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleCheckboxClick = t7;
  const t8 = drop.id;
  const t9 = `tw-bg-iron-950 tw-rounded-xl tw-px-5 tw-py-4 tw-border tw-border-solid tw-transition-all tw-duration-300 tw-cursor-pointer tw-shadow-md desktop-hover:hover:tw-shadow-lg tw-@container ${isChecked ? "tw-border-primary-400" : "tw-border-iron-800 desktop-hover:hover:tw-border-iron-700"}`;
  const t10 = `tw-size-5 tw-flex tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-solid ${isChecked ? "tw-border-primary-400 tw-bg-primary-400/20" : "tw-border-iron-600 tw-bg-iron-800"} tw-cursor-pointer tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-200`;
  let t11;
  if ($[10] !== isChecked) {
    t11 = isChecked && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="tw-size-4 tw-text-primary-400"><path fillRule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 0 1 1.04-.208Z" clipRule="evenodd" /></svg>;
    $[10] = isChecked;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t10 || $[13] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== handleCheckboxClick || $[16] !== t12) {
    t13 = <div className="tw-flex-shrink-0 tw-self-start tw-mr-1" onClick={handleCheckboxClick}>{t12}</div>;
    $[15] = handleCheckboxClick;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== artWork) {
    t14 = artWork && <DropListItemContentMedia media_mime_type={artWork.mime_type} media_url={artWork.url} imageScale={ImageScale.AUTOx450} isCompetitionDrop={true} />;
    $[18] = artWork;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14) {
    t15 = <div className="tw-flex-shrink-0 tw-overflow-hidden tw-bg-iron-800 tw-min-h-[106px] tw-min-w-[106px] @md:tw-size-[106px] @xs:tw-w-full @xs:tw-h-56 @sm:tw-w-full @sm:tw-h-56 @sm:tw-mb-2 tw-relative"><div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-relative desktop-hover:hover:tw-scale-105 tw-transform tw-duration-300 tw-ease-out"><div className="tw-absolute tw-inset-0 tw-z-[1]">{t14}</div></div></div>;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== drop.title) {
    t16 = <h3 className="tw-text-base tw-font-semibold tw-text-iron-50 tw-mb-0">{drop.title}</h3>;
    $[22] = drop.title;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== drop.rank) {
    t17 = drop.rank && <SingleWaveDropPosition rank={drop.rank} />;
    $[24] = drop.rank;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t16 || $[27] !== t17) {
    t18 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-3">{t16}{t17}</div>;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== drop.author.pfp) {
    t19 = <div className="tw-size-6 tw-relative tw-flex-shrink-0 tw-rounded-md tw-overflow-hidden tw-ring-1 tw-ring-white/10 tw-bg-iron-800">{drop.author.pfp ? <img src={drop.author.pfp} alt="Profile" className="tw-h-full tw-w-full tw-object-contain tw-bg-iron-800" /> : <div className="tw-h-full tw-w-full tw-bg-iron-800 tw-rounded-md tw-ring-1 tw-ring-white/10" />}</div>;
    $[29] = drop.author.pfp;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  const t20 = drop.author.level || 0;
  let t21;
  if ($[31] !== cicType || $[32] !== t20) {
    t21 = <UserCICAndLevel level={t20} cicType={cicType} size={UserCICAndLevelSize.SMALL} />;
    $[31] = cicType;
    $[32] = t20;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  const t22 = drop.author.handle ?? drop.author.id;
  const t23 = `/${drop.author.handle}`;
  let t24;
  if ($[34] !== drop.author.handle) {
    t24 = e_0 => {
      e_0.stopPropagation();
      e_0.preventDefault();
      window.open(`/${drop.author.handle}`, "_blank");
    };
    $[34] = drop.author.handle;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== drop.author.handle || $[37] !== t23 || $[38] !== t24) {
    t25 = <Link href={t23} onClick={t24} className="tw-text-md tw-text-iron-200 desktop-hover:hover:tw-text-opacity-80 tw-transition-colors tw-duration-200 tw-no-underline desktop-hover:hover:tw-underline tw-font-medium tw-truncate">{drop.author.handle}</Link>;
    $[36] = drop.author.handle;
    $[37] = t23;
    $[38] = t24;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  if ($[40] !== t22 || $[41] !== t25) {
    t26 = <UserProfileTooltipWrapper user={t22}>{t25}</UserProfileTooltipWrapper>;
    $[40] = t22;
    $[41] = t25;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[43] !== t19 || $[44] !== t21 || $[45] !== t26) {
    t27 = <div className="tw-flex tw-items-center tw-gap-2 tw-mt-4">{t19}{t21}{t26}</div>;
    $[43] = t19;
    $[44] = t21;
    $[45] = t26;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== drop) {
    t28 = <div onClick={_temp}><MyStreamWaveMyVoteVotes drop={drop} /></div>;
    $[47] = drop;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== drop.id || $[50] !== drop.top_raters) {
    t29 = drop.top_raters?.slice(0, 3).map(voter => <React.Fragment key={voter.profile.handle}><Link href={`/${voter.profile.handle}`} onClick={_temp2} data-tooltip-id={`my-vote-voter-${drop.id}-${voter.profile.handle}`}>{voter.profile.pfp ? <img className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link><Tooltip id={`my-vote-voter-${drop.id}-${voter.profile.handle}`} place="top" offset={8} opacity={1} style={{
        padding: "4px 8px",
        background: "#37373E",
        color: "white",
        fontSize: "13px",
        fontWeight: 500,
        borderRadius: "6px",
        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
        zIndex: 99999,
        pointerEvents: "none"
      }}>{voter.profile.handle} - {formatNumberWithCommas(voter.rating)}</Tooltip></React.Fragment>);
    $[49] = drop.id;
    $[50] = drop.top_raters;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== t29) {
    t30 = <div className="tw-flex tw-items-center -tw-space-x-2">{t29}</div>;
    $[52] = t29;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== drop.raters_count) {
    t31 = formatNumberWithCommas(drop.raters_count);
    $[54] = drop.raters_count;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  const t32 = drop.raters_count === 1 ? "voter" : "voters";
  let t33;
  if ($[56] !== t32) {
    t33 = <span className="tw-text-iron-500 tw-font-normal">{t32}</span>;
    $[56] = t32;
    $[57] = t33;
  } else {
    t33 = $[57];
  }
  let t34;
  if ($[58] !== t31 || $[59] !== t33) {
    t34 = <span className="tw-text-white tw-font-bold tw-text-sm">{t31}{" "}{t33}</span>;
    $[58] = t31;
    $[59] = t33;
    $[60] = t34;
  } else {
    t34 = $[60];
  }
  let t35;
  if ($[61] !== t30 || $[62] !== t34) {
    t35 = <div className="tw-flex tw-items-center tw-gap-2">{t30}{t34}</div>;
    $[61] = t30;
    $[62] = t34;
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] !== t28 || $[65] !== t35) {
    t36 = <div className="tw-flex tw-items-center tw-gap-x-6">{t28}{t35}</div>;
    $[64] = t28;
    $[65] = t35;
    $[66] = t36;
  } else {
    t36 = $[66];
  }
  let t37;
  if ($[67] !== drop || $[68] !== isResetting) {
    t37 = <div onClick={_temp3}><MyStreamWaveMyVoteInput drop={drop} isResetting={isResetting} /></div>;
    $[67] = drop;
    $[68] = isResetting;
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] !== t36 || $[71] !== t37) {
    t38 = <div className="tw-flex tw-flex-col @lg:tw-flex-col @[42rem]:tw-flex-row tw-justify-between tw-gap-4 tw-mt-3.5 xl:tw-mt-3">{t36}{t37}</div>;
    $[70] = t36;
    $[71] = t37;
    $[72] = t38;
  } else {
    t38 = $[72];
  }
  let t39;
  if ($[73] !== t18 || $[74] !== t27 || $[75] !== t38) {
    t39 = <div className="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">{t18}{t27}{t38}</div>;
    $[73] = t18;
    $[74] = t27;
    $[75] = t38;
    $[76] = t39;
  } else {
    t39 = $[76];
  }
  let t40;
  if ($[77] !== t13 || $[78] !== t15 || $[79] !== t39) {
    t40 = <div className="tw-flex @md:tw-flex-row @sm:tw-flex-col @xs:tw-flex-col tw-gap-4">{t13}{t15}{t39}</div>;
    $[77] = t13;
    $[78] = t15;
    $[79] = t39;
    $[80] = t40;
  } else {
    t40 = $[80];
  }
  let t41;
  if ($[81] !== drop.id || $[82] !== handleClick || $[83] !== t40 || $[84] !== t9) {
    t41 = <div key={t8} className={t9} onClick={handleClick}>{t40}</div>;
    $[81] = drop.id;
    $[82] = handleClick;
    $[83] = t40;
    $[84] = t9;
    $[85] = t41;
  } else {
    t41 = $[85];
  }
  return t41;
};
export default MyStreamWaveMyVote;
function _temp(e_1) {
  return e_1.stopPropagation();
}
function _temp2(e_2) {
  return e_2.stopPropagation();
}
function _temp3(e_3) {
  return e_3.stopPropagation();
}